import { Action, initialState, State } from 'store/store';

export const updateAssessment = (
  state: State = initialState,
  { data }: Action
): State => {
  const { assessmentId, assessmentData, questionData } = data;

  // console.log({ assessmentId, assessmentData, questionData });

  const assessment = state.assessments[assessmentId];

  let nextState;

  if (data.delete) {
    // console.log(data);

    delete assessment.results[data.delete.questionId];
    //
    nextState = {
      ...state,
    };

    // console.log(nextState.assessments[assessmentId]);
    return nextState;
  }

  nextState = {
    ...state,

    assessments: {
      ...(state as any).assessments,

      [assessmentId]: {
        ...assessment,
        data: {
          ...assessment?.data,
          ...assessmentData,
        },
        results: {
          ...assessment?.results,
          ...questionData,
        },
      },
    },
  };

  // console.log(nextState.assessments);

  return nextState;
};
